import React from "react";
import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";

const ApplicationThankYouPage: React.FC = () => {
  const location = useLocation();
  const thankYouMessage =
    location.state?.message || "Thank you for your submission!";
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-50 to-white text-gray-800">
      <div className="p-6 bg-white shadow-lg rounded-lg max-w-lg text-center">
        <h1 className="text-2xl font-bold text-green-700 mb-4">
          {" "}
          {intl.formatMessage({
            id: "thankYou.title",
            defaultMessage: "🎉 Thank You!",
          })}
        </h1>
        <p className="text-lg">{thankYouMessage}</p>
        <div className="mt-6">
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 bg-green-600 text-white rounded-xl cursor-pointer transition duration-300"
          >
            {intl.formatMessage({
              id: "global.back",
              defaultMessage: "Go Back",
            })}
          </button>
        </div>
      </div>
      <img src="https://www.talent.com/tracker/img-pixel.php?tracker=spodsit"></img>
      <img
        src="https://click.appcast.io/generic-9k/a17.png?ent=775&e=26142&t=1742467341694"
        style={{ display: "none" }}
        width="1px"
        height="1px"
      />
    </div>
  );
};

export default ApplicationThankYouPage;
